import * as React from 'react';
import { Redirect, RouteChildrenProps } from 'react-router';
import { Link } from 'react-router-dom';
import { useRequestAsync, APIRequest } from '../api/client';

import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import LoginPage from '../components/LoginPage';
import { ProfileContext, ProfileManager } from '../profile';

interface AuthParams {
  email: string;
  password: string;
}

interface Props extends RouteChildrenProps<any> {}

const login = (context: ProfileManager): [APIRequest, Function] => {
  const [state, submit] = useRequestAsync((data: AuthParams) => ({
    url: '/users/login',
    method: 'POST',
    body: JSON.stringify(data),
  }));

  React.useEffect(() => {
    if (!state.data) {
      return;
    }

    context.set(state.data);
  }, [state]);

  return [state, submit];
};

export default (props: Props) => {
  const [email, setEmail] = React.useState(null);
  const [password, setPassword] = React.useState(null);
  const context: any = React.useContext(ProfileContext);
  const [state, submit] = login(context);

  if (state.loading) {
    return <Loader style="light" />;
  }

  if (state.data && state.complete) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <LoginPage {...props}>
      <form
        className="pa4 black-80 ml-auto mr-auto w-70-ns"
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();

          submit({
            email,
            password,
          });
        }}
      >
        <h3 className="f3 f2-ns lh-title ma0 mb2 black">Manage your account</h3>
        <small className="f6 black-60 db mb3 mb4-ns lh-copy">
          Sign in to create, share and view reports of your brew guides on
          Filtru.
        </small>
        {state.error && <ErrorFlash error={state.error} />}
        <div className="mv3-ns measure-wide">
          <label htmlFor="name" className="f6 b db mb2 ttu black-50 fw6">
            Email
          </label>
          <input
            id="name"
            className="input-reset ba b--black-20 pa2 mb2 db w-100"
            type="email"
            required
            onChange={(e) => setEmail(e.target.value)}
            defaultValue={email}
            autoComplete="email"
          />
        </div>
        <div className="mv3-ns measure-wide">
          <label htmlFor="password" className="f6 b db mb2 ttu black-50 fw6">
            Password
          </label>
          <input
            id="password"
            className="input-reset ba b--black-20 pa2 mb2 db w-100"
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <Link className="f6 link db mv3 black-60 b dim" to="/forgot-password">
          Forgot password?
        </Link>
        <button
          className="mv3 mv4-ns db link gold f3 b bw0 bg-ui-white-1 tl pa0 dim pointer bg-animate"
          type="submit"
        >
          Continue →
        </button>
      </form>
    </LoginPage>
  );
};
